// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popover":"popover___1xdPr","icon":"icon___kYabs"};